import { render, staticRenderFns } from "./ProfilesComponent.vue?vue&type=template&id=0bd872b4&scoped=true"
import script from "./ProfilesComponent.vue?vue&type=script&lang=js"
export * from "./ProfilesComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfilesComponent.vue?vue&type=style&index=0&id=0bd872b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd872b4",
  null
  
)

export default component.exports